import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios"

import { ResponseData } from "../common"

export interface SignInWithPasswordRequest extends Partial<AxiosRequestConfig> {
  params: {
    email: string
    password: string
  }
}

interface SignInWithPasswordResponseData extends ResponseData {
  message: string
  isFirstLogin: boolean
}

export interface SignInWithPasswordResponse extends AxiosResponse {
  data: SignInWithPasswordResponseData
}

export function signInWithPasswordAPI(
  { params }: SignInWithPasswordRequest,
  axiosInstance: AxiosInstance,
) {
  return axiosInstance({
    method: "post",
    url: `/auth/${params.email}/signin`,
    data: { password: params.password },
  }) as Promise<SignInWithPasswordResponse>
}
